import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function SocialProof() {
  const testimonials = [{
    text: 'Tenía miedo de perder mi dinero pero llega el link al instante y todo bien.',
    initials: 'M',
    color: 'bg-blue-600'
  }, {
    text: 'Lo amo, súper sencillo y me encanta la explicación de las cafeteras.',
    initials: 'C',
    color: 'bg-rose-600'
  }, {
    text: 'Al principio dudé porque pensé que era puro anuncio, pero sí llega y está súper bonito.',
    initials: 'A',
    color: 'bg-emerald-600'
  }, {
    text: 'Las recetas están buenísimas.',
    initials: 'L',
    color: 'bg-purple-600'
  }];
  return <section className="py-12 px-4 bg-cream-200" data-id="element-175">
      <div className="max-w-6xl mx-auto" data-id="element-176">
        <div className="text-center mb-10" data-id="element-177">
          <h2 className="text-3xl md:text-4xl font-bold text-espresso-900 mb-4" data-id="element-178">
            COMENTARIOS DE LOS CLIENTES
          </h2>
          <div className="flex items-center justify-center gap-2 mb-1" data-id="element-179">
            <div className="flex text-gold-500" data-id="element-180">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-7 h-7 fill-current" data-id="element-181" />)}
            </div>
          </div>
          <p className="text-xl font-bold text-espresso-900" data-id="element-182">⭐ 4.8 / 5</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-183">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white p-5 rounded-2xl shadow-sm border border-espresso-900/5 flex flex-col" data-id="element-184">
              <div className="flex text-gold-500 mb-3" data-id="element-185">
                {[...Array(5)].map((_, idx) => <Star key={idx} className="w-4 h-4 fill-current" data-id="element-186" />)}
              </div>
              <p className="text-espresso-800 italic flex-1 mb-4 text-sm leading-relaxed" data-id="element-187">
                "{t.text}"
              </p>
              <div className="flex items-center gap-3" data-id="element-188">
                <div className={`w-9 h-9 rounded-full ${t.color} text-white flex items-center justify-center font-bold text-sm`} data-id="element-189">
                  {t.initials}
                </div>
                <div className="flex flex-col" data-id="element-190">
                  <span className="font-bold text-espresso-900 text-xs" data-id="element-191">
                    Cliente Verificado
                  </span>
                  <span className="text-xs text-espresso-700 flex items-center gap-1" data-id="element-192">
                    <span className="w-1.5 h-1.5 rounded-full bg-green-500" data-id="element-193"></span>{' '}
                    Compra confirmada
                  </span>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}